import React, { ReactElement, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { useCmsAnalytics } from 'b2b-apps/shop/analytics/hooks';
import { ScrollContext } from 'b2b-apps/shop/app/components/App/App/withScrollRestore';
import { useBreadcrumbs } from 'b2b-apps/shop/breadcrumbs/hooks';
import { useHomepage } from 'b2b-apps/shop/content/hooks';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { getPathnameWithSearch } from 'b2b-apps/shop/routes/utils/url';
import { EnhancedComponentProps, EnhancedComponentType, InjectedProps, WrappedComponentType } from './';

const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const t = useTranslate();
    const { history, location } = props;
    const content: any = useHomepage();
    const getScrollPosition = useContext(ScrollContext);
    useBreadcrumbs([]);

    useCmsAnalytics(content);

    useEffect((): void => {
      if (content.isLoaded && history.action === 'POP') {
        const scrollPosition = getScrollPosition(getPathnameWithSearch(location));
        window.scrollTo(0, scrollPosition);
      }
    }, [content.isLoaded, history.action, location, getScrollPosition]);

    const injectedProps: InjectedProps = {
      content,
      headData: { metaTags: [], title: '' },
      pageTitle: t('Shop Homepage\'s title'),
    };

    return <Component {...injectedProps} {...props} />;
  };

  return compose<EnhancedComponentType>(withRouter)(React.memo(WithContainer));
};

export { withContainer };
